import getConfig from '../../env.js';
import FetchApi from '../fetch-api';
import { isCCApp } from '../../api/api';

let isUserToken = false;
let isEclientToken = false;
let exClientValue = '';
let coreAuthToken = '';
let isCC = false;

function setIsEclientToken() {
  const pathName = window.location.pathname;

  const eclientUsePaths = getConfig('ECLIENT_USE_PATHS').split(',');

  exClientValue = getConfig('EX_CLIENT_VALUE');

  if (eclientUsePaths.indexOf(pathName) !== -1) {
    isEclientToken = true;
  }
}

export const getCookie = (name) =>
  document.cookie
    .split('; ')
    .filter((cookie) => cookie.split('=')[0] === name)
    .map((cookie) => cookie.match(new RegExp(`${name}=(.*)`))[1])[0];

export const clearCookie = (name) => {
  if (isCCApp()) {
    FetchApi(
      `${getConfig('COMMON_UI_JACKET_URL')}/clearHttpOnlyCookie?name=${name}`,
    );
  } else {
    const cookieAttachDomain = getConfig('COOKIE_ATTACH_DOMAIN');
    const cookiesPath = getConfig('COOKIES_PATH');
    document.cookie = `${name}=; domain=${cookieAttachDomain}; path=${cookiesPath}; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
};

export const sanitizeUserContent = (content) => {
  if (content) {
    const sanitizedContent = content
      .replace(/<script>/g, '')
      .replace(/<\/script>/g, '')
      .replace(/<p>/g, '')
      .replace(/<\/p>/g, '')
      .replace(/</g, '')
      .replace(/>/g, '')
      .replace(/&amp;#34;/g, '')
      .replace(/&lt;strong&gt;/g, '')
      .replace(/&lt;\/strong&gt;/g, '')
      .replace(/&lt;em&gt;/g, '')
      .replace(/&lt;\/em&gt;/g, '')
      .replace(/&lt;u&gt;/g, '')
      .replace(/&lt;\/u&gt;/g, '')
      .replace(/&lt;p&gt;/g, '')
      .replace(/&lt;\/p&gt;/g, '')
      .replace(/&amp;#39;/g, '');
    return sanitizedContent;
  }
  return '';
};

function getCCDomain() {
  let cookieAttachCCDomain = getConfig('COOKIE_ATTACH_CC_DOMAIN');
  cookieAttachCCDomain = cookieAttachCCDomain.split(',');
  const {
    location: { origin = '' }
  } = window;
  let result = '';
  cookieAttachCCDomain.forEach((domain) => {
    if (origin.indexOf(domain) !== -1) {
      result = domain;
    }
  });
  return result;
}

export const setCookie = (key, value) => {
  const sameSiteAttibute = getConfig('SAME_SITE_ATTRIBUTE');
  let val = value;
  if (key === 'language') {
    val = sanitizeUserContent(val);
    if (!val) {
      val = getConfig('APPLICATION_LANGUAGE');
    }

    val = val.replace('-', '_');
  }
  const cookieAttachCCDomain = getCCDomain();
  const cookieAttachDomain = getConfig('COOKIE_ATTACH_DOMAIN');
  const cookiesPath = getConfig('COOKIES_PATH');

  const { href = '' } = window.location;
  const normalUrlMatch = getConfig('NORMAL_URL_MATCH');

  if (href.indexOf(normalUrlMatch) === -1) {
    if (key === 'language') {
      document.cookie = `${key}=${val}; domain=${cookieAttachCCDomain}; path=${cookiesPath}`;
    } else {
      const postObj = {
        cookieName: key,
        cookieValue: val
      };
      FetchApi(
        `${getConfig('COMMON_UI_JACKET_URL')}/setHttpOnlyCookie`,
        {},
        false,
        'post',
        postObj,
      );
    }
  } else if (cookieAttachDomain) {
    document.cookie = `${key}=${val}; domain=${cookieAttachDomain}; path=${cookiesPath}; SameSite=${sameSiteAttibute}; secure`;
  } else {
    document.cookie = `${key}=${val}; path=/; SameSite=${sameSiteAttibute}; secure`;
  }
};

export const setCoreAuthToken = (val) => {
  coreAuthToken = val;
};

function getTokenValue() {
  let tokenVal = '';
  if (coreAuthToken.length > 0) {
    tokenVal = coreAuthToken;
  } else if (isEclientToken) {
    tokenVal = getCookie('_eclientlink_access_token');
  } else {
    tokenVal = getCookie('_access_token');
  }
  return tokenVal;
}
export const getAuthToken = () => {
  let token = getTokenValue();
  if (!token) {
    token = getCookie('access_token');
  }
  if (isEclientToken) {
    return token
      ? { Authorization: `Bearer ${token}`, 'X-Client-id': exClientValue }
      : null;
  }
  return token ? { Authorization: `Bearer ${token}` } : null;
};

export const getUserAccessToken = () => {
  let token = getTokenValue();
  if (!token) {
    token = getCookie('access_token');
  }
  return token;
};

export const setIsCC = (val) => {
  isCC = val;
};

export const getIsCC = () => isCC;

export const setIsUserToken = () => {
  setIsEclientToken();
  const { href = '' } = window.location;
  const normalUrlMatch = getConfig('NORMAL_URL_MATCH');
  const token = getTokenValue();
  if (href.indexOf(normalUrlMatch) === -1) {
    setIsCC(true);
  }
  if (isEclientToken || token || href.indexOf(normalUrlMatch) === -1) {
    isUserToken = true;
  } else {
    isUserToken = false;
  }
};

export const getIsUserToken = () => isUserToken;

export const getIsCookieDisabled = () => {
  const { cookieEnabled } = navigator;
  if (typeof cookieEnabled === 'boolean') {
    return !cookieEnabled;
  }
  return false;
};

export const getIsEclientToken = () => isEclientToken;

export const getTime = () => {
  const date = new Date().getTime() / 1000;
  return parseInt(date, 10);
};

export const getValueFromUrl = (key) => {
  const url = window.location.href;
  // eslint-disable-next-line
  const name = key.replace(/[\[\]]/g, "\\$&");
  // eslint-disable-next-line
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const getParamLanguage = (x) => {
  let locale = getValueFromUrl('locale');
  if (locale) {
    const key = 'language';
    setCookie(key, locale);
    return locale;
  }
  locale = getCookie('language');
  if (!locale) {
    locale = x;
  }
  return locale;
};

export const getSpecificUrl = (val) => {
  if (isCC) {
    return getConfig(`CC_${val}`);
  }
  return getConfig(val);
};
